import { defineMessages } from 'react-intl';

const _default_1: {
	iconLabel: {
		id: string;
		defaultMessage: string;
		description: string;
	};
	addTeamIconLabel: {
		id: string;
		defaultMessage: string;
		description: string;
	};
	teamBtnLabel: {
		id: string;
		defaultMessage: string;
		description: string;
	};
} = defineMessages({
	iconLabel: {
		id: 'team-button-trigger.icon.label',
		defaultMessage: 'Team button',
		description: 'Label for the team button icon',
	},
	addTeamIconLabel: {
		id: 'team-button-trigger.add-team-icon.label',
		defaultMessage: 'Add team',
		description: 'Accessibility label for the icon button that adds a team to the project',
	},
	teamBtnLabel: {
		id: 'team-button-trigger.team-btn.label',
		defaultMessage: 'Link contributing teams',
		description: 'Button label text for linking contributing teams to a project or goal',
	},
});
export default _default_1;
